export const shortDateAndTimeFormat = 'MM/dd/yy kk:mm';
export const shortDateFormat = 'MM/dd/yy';
export const shortDateAndFullTimeFormat = 'MM/dd/yy kk:mm:ss';

